<template>
  <ModalContainer
    :showModal="showModal"
    :title="isEdit ? 'Edit Coupon' : 'Create New Coupon'"
    @closeModal="closeModal"
  >
    <div id="modal-body" class="p-6">
      <AlertDanger
        v-if="alert_danger"
        :text="alert_text"
        @closeAlertDanger="hideAlertDanger()"
      />
      <div class="flex flex-col gap-4">
        <InputForm
          id="coupon-name"
          input_class="w-full"
          label="Coupon Name"
          label_class="mb-1 block text-start"
          type="text"
          placeholder="e.g. 1"
          v-model="coupon.name"
        />
        <div>
          <InputForm
            id="max-usage"
            input_class="w-full"
            label="Max Usage"
            label_class="mb-1 block text-start"
            type="number"
            placeholder="e.g. 1"
            v-model="coupon.max_usage"
          />
          <p class="text-white/70 text-xs font-light w-full text-right">
            *leave blank for unlimited coupon
          </p>
        </div>
        <Select
          label="Promo Product"
          id="product"
          option_placeholder="Select Product"
          select_class="w-full"
          valueKey="id"
          labelKey="products_name"
          :options="allProducts"
          v-model="coupon.product_id"
        />
        <div class="flex items-center gap-2">
          <div class="flex items-center gap-2">
            <input
              type="radio"
              id="on-percentage"
              v-model="coupon.on_percentage"
              :value="false"
            />
            <label for="on-fixed">On Fixed</label>
          </div>
          <div class="flex items-center gap-2">
            <input
              type="radio"
              id="on-percentage"
              v-model="coupon.on_percentage"
              :value="true"
            />
            <label for="on-percentage">On Percentage</label>
          </div>
        </div>
        <InputRupiah
          id="discount"
          input_class="w-full"
          label="Discount"
          type="number"
          placeholder="e.g. 10000"
          v-model="coupon.discount"
          v-if="!coupon.on_percentage"
        />
        <InputText
          id="discount"
          input_class="w-full"
          label="Discount"
          type="number"
          placeholder="e.g. 10000"
          v-model="coupon.discount"
          v-if="coupon.on_percentage"
        />
        <InputText
          id="expiry-days"
          label="Expiry Days"
          label_class="mb-1 block text-start"
          input_class="w-full"
          type="number"
          placeholder="e.g. 30"
          span_text="Days"
          span_class="right-6 bottom-1"
          v-model="coupon.expiry_days"
        />
      </div>
    </div>
    <div class="modal-footer pb-6">
      <div class="flex justify-center gap-2">
        <Button id="close-modal" button_text="Cancel" @click="closeModal" />
        <SubmitButton
          @click="submit()"
          :is_loading="loadingSubmit"
          :is_disabled="loadingSubmit"
          id="submit"
          button_text="Submit"
        />
      </div>
    </div>
  </ModalContainer>
</template>
<script>
import InputForm from "@/components/form/InputForm.vue";
import AlertDanger from "@/components/alerts/AlertDanger.vue";
import ModalContainer from "@/components/modals/ModalContainer.vue";
import InputText from "@/components/form/InputText.vue";
import InputRupiah from "../form/InputRupiah.vue";
import Button from "@/components/buttons/Button.vue";
import SubmitButton from "../form/SubmitButton.vue";
import Select from "@/components/form/Select.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ModalAddCoupon",
  props: {
    couponData: {
      type: Object,
      default: {},
    },
  },
  emits: ["openAlertSuccess", "closeModal"],
  components: {
    InputForm,
    AlertDanger,
    ModalContainer,
    InputText,
    InputRupiah,
    Button,
    SubmitButton,
    Select,
  },
  data() {
    return {
      showModal: true,
      alert_danger: false,
      alert_text: "",

      isEdit: false,
      loadingSubmit: false,

      coupon: {
        id: null,
        code: "",
        discount: 0,
        max_usage: null,
        expiry_days: null,
        product_id: null,
        expiry_period_per_branch: [],
        on_percentage: false,
      },
      // expiryPeriods: []
    };
  },
  beforeMount() {
    if (this.couponData) {
      this.isEdit = true;
      // console.log('kupon to edit: ', this.couponData);
      this.coupon.id = this.couponData.id;
      this.coupon.name = this.couponData.name;
      this.coupon.product_id = this.couponData.product_id;
      this.coupon.expiry_days =
        this.couponData.expiry_period_per_branch[0]?.expire_days || null;
      this.coupon.max_usage = parseInt(this.couponData.max_usage);
      this.coupon.discount = parseInt(this.couponData.discount);
      // console.log('this.coupon: ', this.coupon);
    }
  },
  created() {
    this.$store.dispatch("branches/fetchBranches");
    this.$store.dispatch("products/fetchProducts");
  },
  computed: {
    ...mapGetters("branches", ["allBranches"]),
    ...mapGetters("products", ["allProducts"]),

    filteredCoupon() {
      return this.allCoupon;
    },
  },
  methods: {
    ...mapActions("coupons", ["createCoupon", "updateCoupon"]),

    closeModal() {
      this.showModal = false;
      setTimeout(() => {
        this.$emit("closeModal");
      }, 100);
    },
    async submit() {
      // this.coupon.expiry_period_per_branch = this.expiryPeriods;
      if (!this.coupon.name) {
        this.showAlert("failed", "Coupon name cannot be empty!");
        return;
      }
      if (!this.coupon.product_id) {
        this.showAlert("failed", "Product cannot be empty!");
        return;
      }
      if (this.coupon.max_usage < 0 || this.coupon.expiry_days < 0) {
        this.showAlert(
          "failed",
          "Max Usage and Expiry Days cannot be negative!"
        );
        return;
      }

      this.allBranches.forEach((branch) => {
        const coupon_branch = {
          branch_id: parseInt(branch.id),
          branch_name: branch.name,
          expire_days: this.coupon.expiry_days
            ? parseInt(this.coupon.expiry_days)
            : null,
        };
        this.coupon.expiry_period_per_branch.push(coupon_branch);
      });
      this.coupon.max_usage = parseInt(this.coupon.max_usage);
      // console.log('kupon : ', this.coupon);
      if (this.couponData) {
        // console.log('kupon to update: ', this.coupon);
        this.loadingSubmit = true;
        await this.updateCoupon(this.coupon);
        this.closeModal();
        this.loadingSubmit = false;
      } else {
        try {
          // console.log('kupon baru: ', this.coupon);
          this.loadingSubmit = true;
          await this.createCoupon(this.coupon);
          this.closeModal();
          this.loadingSubmit = false;
        } catch (error) {
          this.loadingSubmit = false;
          console.error(error);
        }
      }
    },
    hideAlertDanger() {
      this.alert_danger = false;
      this.alert_text = "";
    },
    showAlert(type, text) {
      if (type == "success") {
        this.alert_success = true;
        this.alert_text = text;
      } else {
        this.alert_danger = true;
        this.alert_text = text;
      }
      setTimeout(() => {
        this.alert_success = false;
        this.alert_danger = false;
        this.alert_text = "";
      }, 2000);
    },
    // updateExpireDays(index, value) {
    //   // Validasi apakah expiryPeriods[index] ada
    //   if (this.expiryPeriods[index]) {
    //     this.expiryPeriods[index].expire_days = value;
    //   }
    // },
  },
};
</script>
